import queryString from 'query-string';
import fetch from 'isomorphic-fetch';
require('es6-promise').polyfill();

import { checkHttpStatus, parseJSON } from '../../utils';

import {
  _PENDING,
  _SUCCESS,
  _FAILURE
} from '../../constants/api';
import EXPLORE_API from '../../constants/symbols';

const apiMiddleware = store => next => action => {

  if(!action.hasOwnProperty(EXPLORE_API)) {
    return next(action);
  }

  store.dispatch({ type: action.type, payload: action.payload });

  const { url, body, ...rest } = action[EXPLORE_API];
  const options = {
    ...rest,
    credentials: 'same-origin',
    headers: {
      'Content-Type':'application/x-www-form-urlencoded; charset=UTF-8'
    }
  }
  if(body) {
    options.body = queryString.stringify(body);
  }

  // @todo: figure out what `next({})` isn't working
  const promise = fetch(`${SERVER_URL}/${url}`, options)
    .then(checkHttpStatus)
    .then(parseJSON)
    .then( (response) => {
      store.dispatch({
        type: action.type + _SUCCESS,
        payload: response
      });
    })
    .catch((err, message)=> {
      store.dispatch({
        type: action.type + _FAILURE,
        err
      });
      return Promise.reject(new Error(err));
    });

  store.dispatch({ type: action.type + _PENDING, payload: action.payload });

  return promise;

};

export default apiMiddleware;
